// extracted by mini-css-extract-plugin
module.exports = {"resolution":"InstrumentChart_resolution__hvIPo","trade-buttons":"InstrumentChart_trade-buttons__nskDn"};